module.exports = __webpack_public_path__ + "img/图片7.dc61af39.png";